module.exports = __webpack_public_path__ + "static/media/season-img2.35e95324.jpg";